import React from "react";
import { Button, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "./ReviewPopup.css";

const ReviewPopup = ({ selectedRecord, onApprove, onReject, onClose }) => {
  if (!selectedRecord) {
    return null;
  }

  const { sourceData, ahpraResponseData, matchingStatus, approvalStatus } =
    selectedRecord;

  return (
    <div className="review-popup-overlay">
      <div className="review-popup-container">
        {/* Header Section */}
        <div className="review-popup-header">
          <Typography variant="h5" className="review-popup-title">
            Review Record for Approval
          </Typography>
          <IconButton onClick={onClose} className="review-close-button">
            <CloseIcon />
          </IconButton>
        </div>

        {/* Matching Status and Approval Status */}
        <div className="review-status-container">
          <Typography variant="body1">
            <strong>Matching Status:</strong>{" "}
            <span className="status-value">{matchingStatus || ""}</span>
          </Typography>
          <Typography variant="body1">
            <strong>Approval Status:</strong>{" "}
            <span className="status-value">{approvalStatus || ""}</span>
          </Typography>
        </div>

        {/* Comparison Table */}
        <div className="review-table-container">
          <table className="review-comparison-table">
            <thead>
              <tr>
                <th>Field</th>
                <th>Source Data</th>
                <th>AHPRA Response Data</th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(sourceData).map((field) => (
                <tr key={field}>
                  <td className="review-field-column">
                    {/* {field.replace(/([A-Z])/g, " $1")} */}
                    {
                      field
                        .replace(/([A-Z])/g, " $1") 
                        .replace(/^./, (str) => str.toUpperCase()) 
                        .replace(/\b\w/g, (char) => char.toUpperCase())
                    }
                  </td>
                  <td
                    className={
                      sourceData[field]?.toString().trim().toLowerCase() !==
                      ahpraResponseData[field]?.toString().trim().toLowerCase()
                        ? "mismatched-field"
                        : ""
                    }
                  >
                    {sourceData[field] || "N/A"}
                  </td>
                  <td
                    className={
                      sourceData[field]?.toString().trim().toLowerCase() !==
                      ahpraResponseData[field]?.toString().trim().toLowerCase()
                        ? "mismatched-field"
                        : ""
                    }
                  >
                    {ahpraResponseData[field] || "N/A"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Actions Section */}
        <div className="review-popup-actions">
          <Button
            variant="contained"
            color="success"
            onClick={() => onApprove(selectedRecord)}
            className="review-approve-button"
          >
            Approve
          </Button>
          <Button
            variant="outlined"
            color="error"
            onClick={() => onReject(selectedRecord)}
            className="review-reject-button"
          >
            Reject
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ReviewPopup;
